/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import { mobileOrderItemGroupUnionModifierCreateRequestSchema } from "./mobileOrderItemGroupUnionModifierCreateRequestSchema.ts";
import { mobileOrderItemModifierCreateRequestSchema } from "./mobileOrderItemModifierCreateRequestSchema.ts";

export const mobileOrderItemCreateRequestSchema = z.object({
	id: z.uuid(),
	amount: z.int().min(1),
	size: z.uuid().nullish(),
	comment: z.string().max(120).nullish(),
	modifiers: z.array(mobileOrderItemModifierCreateRequestSchema).nullish(),
	group_modifiers: z.array(mobileOrderItemGroupUnionModifierCreateRequestSchema).nullish(),
	front_item_id: z.uuid().nullish(),
	marking_code: z.string().min(1).nullish(),
});
